// ! ||--------------------------------------------------------------------------------||
// ! ||                                   PDP Offers                                   ||
// ! ||--------------------------------------------------------------------------------||
class ExtendProductOffer extends HTMLElement {
    constructor(productForm, addToCartButton) {
        super();

        const referenceId = productForm.querySelector('input[name="id"]').value;
        const price = meta.product.variants.filter(variant => variant.id == referenceId)[0].price;
        const category = meta.product.type;

        this.params = {
            referenceId,
            price,
            category
        }
        
        this.config = getConfiguration();
        this.config.dispatchSideCart = false;
        
        this.productForm = productForm;
        this.addToCartButton = addToCartButton;
        
    }
    
    connectedCallback() {
        try {
            this.verifyProductOffer();
        } catch (err) {
            console.error(err.message);
            return;
        }
     
        this.bindEvents();
        this.style.display = 'block';
        
        if (!this.config.pdpOfferEnabled) this.style.display = 'none';
        // Renders Extend offer
        Extend.buttons.render(this, this.params);
    }
    
    bindEvents() {
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);
        
        this.productForm.addEventListener('change', this.handleVariantChange.bind(this), true);
    }
    
    verifyProductOffer() {

        let elementsToCheck = [
            'this.productForm',
            'this.addToCartButton',
            'this.params.referenceId',
            'this.params.price',
            'this.params.category'
        ]
        
        let missingElements = elementsToCheck.filter((value) => {
            try {
                return !eval(value);
            } catch (err) {
                return true;
            }
        });
        
        if (missingElements.length) {
            let message = "The following value(s) are null or undefined:\n";
            missingElements.forEach((value) => {
                message += `\t${value}\n`;
            });
            throw new ExtendError(message);
        }
        
        // Checks if Extend lives in the window and the active currency is USD before showing Extend offers
        verifyExtend();
        
    }

    modalDone() {
        // remove default click listener
        this.addToCartButton.removeEventListener('click', this.handleAddToCart, true);
        // click atc button
        this.addToCartButton.click();
        // add default click listener back
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);

        // If variable set to true, dispatches Extend side cart integration to run after adding to cart via pdp
        if (this.config.dispatchSideCart) window.setTimeout(() => {
            initCartOffer();
        }, 500);
    }
    
    /**
    * Handle add to cart event with offers
    * @param {PointerEvent} e Click event from Add To Cart Button
    */
    handleAddToCart(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        const quantityEl = this.productForm.querySelector('[name="quantity"]');
        const quantity = quantityEl && quantityEl.value ? quantityEl.value : 1;
        
        ExtendShopify.handleAddToCart(this, {
            quantity: quantity,
            modal: this.config.modalOfferEnabled,
            done: this.modalDone.bind(this)
        });
    }
    
    handleVariantChange() {
        // Flicker prevention

        this.params.referenceId = this.productForm.querySelector('input[name="id"]').value;
        this.params.price = meta.product.variants.filter(variant => variant.id == this.params.referenceId)[0].price;
        
        
        Extend.setActiveProduct(this, this.params);
    }
}
if (!customElements.get('extend-offer'))
    customElements.define('extend-offer', ExtendProductOffer);

/**
* Initializes product offers and handles ATC button functionality for the main PDP ATC
*/
function initProductOffer() {
    // Not a product page: expected on every other template. Return silently
    // instead of warning — this logged on the home page, collections, cart, etc.
    if (meta.page.pageType != 'product' || !meta.product) {
        return;
    }

    /*
      Selectors are resilient on purpose — a single missed match here used to
      throw `null.parentElement`, and the init's try/catch only logs when
      sessionStorage['extend.debug'] is set, so the offer vanished silently.

      form: matched with *= rather than an exact "/cart/add". Shopify prefixes
      the action with the locale/market root on multi-locale storefronts
      (/en-gb/cart/add), which an exact match misses.

      button: `button[name="add"]` is the Shopify convention and is now emitted
      by snippets/buy-buttons.liquid. The extra fallbacks cover a theme update
      dropping that attribute again, so this degrades instead of disappearing.
    */
    const productForm =
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('product-form form') ||
        null;

    const addToCartButton =
        (productForm && productForm.querySelector('button[name="add"]')) ||
        document.querySelector('buy-buttons button[type="submit"]') ||
        document.querySelector('button[name="add"]') ||
        (productForm && productForm.querySelector('button[type="submit"]')) ||
        null;

    if (!addToCartButton || !addToCartButton.parentElement) {
        // Loud on purpose. This is the exact failure that hid the PDP offer.
        console.warn('[Extend] add-to-cart button not found — PDP protection-plan offer not rendered.');
        return;
    }

    // Create offer and render it
    const extendOffer = new ExtendProductOffer(productForm, addToCartButton);
    addToCartButton.parentElement.before(extendOffer);
}

// ! ||--------------------------------------------------------------------------------||
// ! ||                                   Cart Offers                                  ||
// ! ||--------------------------------------------------------------------------------||

const cartOfferTag = 'extend-cart-offer';
var cart;
var init = false;

const {
    cartOfferEnabled,
    cartSPEnabled,
    sideCartOfferEnabled,
    cartBalancingEnabled,
    SPEnabled
} = getConfiguration();

let type, selectors;
if (meta.page.pageType === 'cart' && (cartOfferEnabled || cartSPEnabled)) {
    /* ------------------------------------------------------------------
       Von Diamonds: selectors repointed from QD's cart DOM to PRESTIGE's.

       This file was copied verbatim from the QD theme, so every selector
       below still described QD markup (.cart__page, .cart__item,
       .cart__item-name …). NONE of those exist in Prestige, so
       renderOrStyleCart() threw "Invalid cart container selector" on the very
       first call and the Extend cart offer never rendered at all.

       Prestige equivalents (see snippets/line-item.liquid):
         .cart-page / .cart-drawer__items  → cart containers
         <line-item>                       → one row per cart line
         .line-item__title                 → title element (hook added by us)
         .line-item__media                 → product image
         .line-item__extend-anchor         → insertion point (hook added by us)
         .vd-li-props / .vd-li-prop        → line-item property list + rows
         line-item-quantity                → quantity wrapper
       ------------------------------------------------------------------ */
    selectors = {
        cartContainer: '.cart-page',
        cartRowItem: 'line-item', // Container element for each item in the cart
        cartRowItemImage: '.line-item__media', // Product image or image anchor element
        cartRowItemTitle: '.line-item__title', // Title anchor element for the product
        cartRowItemQuantity: 'input[name="updates[]"]', // Input element containing the product quantity
        warrantyOriginalMeta: '.vd-li-props .vd-li-prop', // Each warranty metadata item we want to remove.
        offerAnchor: '.line-item__extend-anchor', // Container where the offer will be appended
        metadataContainer: '.vd-li-props', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: 'line-item-quantity', // Wrapper for quantity input and buttons
        lineItemRemove: 'line-item-quantity a', // Remove button for a line item
        shippingAnchor: '.cart-footer', // Shipping protection offer anchor element
        cartForm: '#CartPageForm'
    }
    type = 'main';
} else if (sideCartOfferEnabled) {
    selectors = {
        cartContainer: '.cart-drawer__items',
        cartRowItem: 'line-item', // Container element for each item in the cart
        cartRowItemImage: '.line-item__media', // Product image or image anchor element
        cartRowItemTitle: '.line-item__title', // Title anchor element for the product
        cartRowItemQuantity: 'input[name="updates[]"]', // Input element containing the product quantity
        warrantyOriginalMeta: '.vd-li-props .vd-li-prop', // Each warranty metadata item we want to remove.
        offerAnchor: '.line-item__extend-anchor', // Container where the offer will be appended
        metadataContainer: '.vd-li-props', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: '', // Wrapper for quantity input and buttons
        lineItemRemove: 'line-item-quantity a', // Remove button for a line item
        shippingAnchor: '.cart-drawer__footer', // Shipping protection offer anchor element
        cartForm: '#CartDrawerForm'
    }
    type = 'side';
}

if (type === undefined || selectors === undefined) {
    throw new ExtendError('No cart type detected');
}

class ExtendCartOffer extends HTMLElement {
    constructor(referenceId, quantity, price, category) {
        super();
        
        this.params = {
            referenceId,
            quantity,
            price,
            category
        }
    }
    
    connectedCallback() {
        this.render();
    }
    
    render() {
        Extend.buttons.renderSimpleOffer(this, {
            referenceId: this.params.referenceId,
            price: this.params.price,
            category: this.params.category,
            onAddToCart: ({ plan, product }) => {
                ExtendShopify.addPlanToCart({
                    plan,
                    product,
                    quantity: this.params.quantity
                }, (err) => {
                    if (err) {
                        throw new ExtendError(err.message);
                    }
                    document.dispatchEvent(new Event('extend.lineItemModified'));
                })
            }
        })
    }
}
if (!customElements.get(cartOfferTag))
    customElements.define(cartOfferTag, ExtendCartOffer);

function createWarrantyOffer(lineItemElement, index) {
    if (!cartOfferEnabled) return;

    const cartItem = cart.items[index];
    const referenceId = cartItem.id;
    const quantity = cartItem.quantity;
    const price = cartItem.price;
    const category = cartItem.product_type;
    const warrantyAlreadyInCart = ExtendShopify.warrantyAlreadyInCart(referenceId, cart.items) || ExtendShopify.warrantyAlreadyInCart(referenceId.toString(), cart.items);
    
    let anchor = lineItemElement.querySelector(selectors.offerAnchor);
    
    if (!anchor) {
        throw new ExtendError(`Offer anchor element on line ${index} not found with selector ${selectors.offerAnchor}`);
    }
    
    let extendOffer = lineItemElement.querySelector(cartOfferTag);
    
    // If there's already an offer element, check that the properties match what we are trying to create
    // If they do not match, or the warranty is already in cart, remove the offer
    if (extendOffer) {
        if (extendOffer.params.referenceId !== referenceId ||
            extendOffer.params.quantity !== quantity ||
            extendOffer.params.price !== price ||
            extendOffer.params.category !== category ||
            warrantyAlreadyInCart
        ) {
            extendOffer.remove();
            // If they do match and the warranty is not already in the cart, do not create a new offer
            // TODO: Handle if new element is not needed, but there is no offer placement rendered
        } else {
            return;
        }
        // If there is no offer element, but the warranty is already in cart, do not create a new offer
    } else if (warrantyAlreadyInCart) {
        return;
    }
    
    let newExtendOffer = new ExtendCartOffer(referenceId, quantity, price, category);
    
    anchor.before(newExtendOffer); // append, prepend, after, before
}
function styleWarrantyLineItem(lineItemElement, index) {
    const title = lineItemElement.querySelector(selectors.cartRowItemTitle);
    title.style.pointerEvents = 'none';
    title.innerText = 'Extend Protection Plan';
    
    const image = lineItemElement.querySelector(selectors.cartRowItemImage);
    
    if (image) {
        image.style.pointerEvents = 'none';
    } else {
        console.error(`EXTEND: Line item image element on line ${index} not found with selector ${selectors.cartRowItemImage}`)
    }
    
    const warrantyMetadata = lineItemElement.querySelectorAll(selectors.warrantyOriginalMeta);
    
    if (warrantyMetadata?.length) {
        warrantyMetadata.forEach(each => each.remove());
    }
    
    if (selectors.quantityWrapper?.length && lineItemElement.querySelector(selectors.quantityWrapper)) {
        lineItemElement.querySelectorAll(selectors.quantityWrapper).forEach((each) => {
            each.style.opacity = '75%';
            each.style.pointerEvents = 'none';
        });
    }
    
    const contentContainer = lineItemElement.querySelector(selectors.metadataContainer)
    let warrantyProductData;
    let warrantyTermData;
    const cartItem = cart.items[index];
    
    if (cartItem.options_with_values && cartItem.options_with_values[1]) { // Finds the ref id string in the product info string and replaces with an empty string
        let regexReplace = cartItem.options_with_values[0].value.match(/\-\d{5,}/g);
        warrantyProductData = cartItem.options_with_values[0].value.replace(regexReplace, '');
        warrantyTermData = cartItem.options_with_values[1].value;
    } else {
        warrantyProductData = cartItem.properties.Product;
        warrantyTermData = cartItem.properties.Term;
    }
    
    // For category offers, fetch title by filtering through cart for warranted product refId
    if (warrantyProductData === "Covered Product") {
        const coveredProductId = cartItem.properties['_Extend.ProductId'];
        warrantyProductData = cart.items.find((item) => item.id.toString() == coveredProductId).title;
    }
    
    // Appends Product and Term metadata
    if (lineItemElement.querySelector(selectors.metadataContainer)) {
        const warrantyProductName = document.createElement('div');
        const originalMetaClass = ['.', '#'].includes(selectors.warrantyOriginalMeta.split(' ').toReversed()[0].charAt(0)) ? 
            selectors.warrantyOriginalMeta.split(' ').toReversed()[0].substring(1) :
            '';

        warrantyProductName.className = `${originalMetaClass} extend-warranty-info extend-warranty-info-product`;
        warrantyProductName.innerHTML = `<span><strong>Product: </strong></span>${warrantyProductData}`;
        
        const warrantyProductTerm = document.createElement('div')
        warrantyProductTerm.className = `${originalMetaClass} extend-warranty-info extend-warranty-info-term`;
        warrantyProductTerm.innerHTML = `<span><strong>Term: </strong></span>${warrantyTermData}`;
        
        // Only append the metadata if it's not already there
        if (!lineItemElement.querySelector('.extend-warranty-info')) {
            contentContainer.append(warrantyProductName, warrantyProductTerm)
        }
    }
}

function renderOrStyleCart() {
    let cartContainer = document.querySelector(selectors.cartContainer);

    // An absent container is a NORMAL state, not an error: Prestige only renders
    // `.cart-page` / `.cart-drawer__items` when the cart has items, so on every
    // page with an empty cart this threw an unhandled promise rejection into the
    // console. No container means no line items, so there is simply nothing to
    // decorate — return quietly.
    if (!cartContainer) {
        return;
    }
    
    cartContainer.querySelectorAll(selectors.cartRowItem).forEach((lineItemElement, index) => {
        let title = lineItemElement.querySelector(selectors.cartRowItemTitle);
        
        if (!title) {
            throw new ExtendError('Line item title not found');
        }
        
        let lowerCaseTitle = title.innerText.toLowerCase();
        
        if (lowerCaseTitle.includes('extend protection')) {
            styleWarrantyLineItem(lineItemElement, index);
        } else {
            createWarrantyOffer(lineItemElement, index);
        }
    });
}

function normalizeItems(callback) {
    if (SPEnabled) {
        ExtendShopify.updateExtendLineItems({
            balanceCart: cartBalancingEnabled,
            isSPSupported: cartSPEnabled,
            callback
        });
    } else {
        let normalizationOpts = {
            balance: cartBalancingEnabled
        }
        ExtendShopify.normalizeCart(normalizationOpts, callback);
    }
}

function refreshCart() {
    if (type === 'side') {
        document.dispatchEvent(new Event('cart:build'));
        setTimeout(initCartOffer, 250);
    } else if (type === 'main') {
        document.dispatchEvent(new Event('cart:build'));
        setTimeout(initCartOffer, 250);
    } else {
        window.location.reload();
    }
}

function verifyCartOffers() {
    verifyExtend();

    let error = '';
    if (!selectors) error = `Cart selectors are empty\n`;

    if (!type) error += `Cart type not defined\n`;

    if (error.length > 0) {
        throw new ExtendError(`Cannot initialize cart offers due to following errors:\n${error}`);
    }
}

function initEventListeners() {

    const cartObserver = new PerformanceObserver(list => {
        list.getEntries().forEach(entry => {
            const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType)
            const isCartChangeRequest = /\/cart\/change/.test(entry.name);
            const isCartAddRequest = /\/cart\/add/.test(entry.name);
            
            if (isValidRequestType && isCartChangeRequest) {
                setTimeout(initCartOffer, 250);
            } else if (isValidRequestType && isCartAddRequest) {
                getCart()
                .then((newCart) => {
                    if (newCart.items.length > 1 || newCart.items[0].vendor != 'Extend') {
                        refreshCart();
                        setTimeout(initCartOffer, 250);
                    }
                });

            }
        })
    })
    cartObserver.observe({ entryTypes: ['resource'] });

    // Prevent cart form submission without normalizing.
    // Null-guarded: the drawer form only exists once the drawer has rendered,
    // and an unguarded dereference here threw a TypeError that aborted
    // initEventListeners() before `init = true` — leaving Extend permanently
    // half-initialised on that page load.
    let cartForm = document.querySelector(selectors.cartForm);
    if (cartForm) {
        cartForm.addEventListener('keydown', (e) => {
            if (e.code == 'Enter') {
                e.preventDefault();

                document.activeElement.blur();
            }
        });
    }

    init = true;
}

function initCartOffer() {
    verifyCartOffers();

    try {
        if (!/cart/.test(window.location.pathname) && !sideCartOfferEnabled) {
            throw new ExtendError('Cannot initialize cart offers - not a cart page');
        }
    } catch (err) {
        console.warn(err.message);
        return;
    }

    if (!init) initEventListeners();

    normalizeItems((err, data) => {
        cart = data?.cart;
        if (err) {
            throw new ExtendError(err.message);
        }

        if (data?.updates) {
            refreshCart();
        } else {
            renderOrStyleCart();
        }
    });
}

// ! ||--------------------------------------------------------------------------------||
// ! ||                                      Utils                                     ||
// ! ||--------------------------------------------------------------------------------||
class ExtendError extends Error {
    constructor(message) {
        super(message);
    }
}

function getConfiguration() {
    return {
        currency: 'USD',
        writeLogsEnabled: false,
        pdpOfferEnabled: true,
        offerModalEnabled: true,
        cartOfferEnabled: true,
        sideCartOfferEnabled: true,
        cartBalancingEnabled: true,
        aftermarketModalEnabled: true,
        atcOfferEnabled: true,
        quickviewOfferEnabled: true,
        quickviewModalOfferEnabled: true,
        cartSPEnabled: false,
        SPEnabled: false,
    };
}

function verifyExtend() {
    const propertiesToCheck = [
        'window.Extend',
        'window.ExtendShopify',
        'window.Shopify',
        'window.Shopify.currency.active'
    ];
    
    function checkPropertyExists(path) {
        return path.split('.').reduce((obj, prop) => obj && obj[prop], window) !== undefined;
    }
    
    let errors = propertiesToCheck.filter(prop => !checkPropertyExists(prop));
    
    // Check for currency mismatch
    if (window.Shopify?.currency?.active !== getConfiguration().currency) {
        errors.push('window.Shopify.currency.active == config.currency');
    }
    
    if (errors.length) {
        let message = "The following value(s) are null, undefined, or false:\n";
        errors.forEach((error) => {
            message += `\t${error}\n`;
        });
        throw new ExtendError(message);
    }
}

function initAftermarket() {
    try {
        verifyExtend();

        // Get params from URL
        const params = (new URL(document.location)).searchParams;

        // Check if leadToken or leadtoken is in the URL
        let leadToken = params.get('leadToken')
            ? params.get('leadToken')
            : params.get('leadtoken');

        if (leadToken) {
            Extend.aftermarketModal.open({
                leadToken: leadToken,
                onClose: function (plan, product, quantity) {
                    if (plan && product) {
                        ExtendShopify.addPlanToCart({
                            plan: plan,
                            product: product,
                            leadToken: leadToken,
                            quantity: quantity || 1
                        }, function () {
                            location = '/cart'
                        })
                    }
                }
            });
        }
    } catch (error) {
        throw new ExtendError( error.message);
    }
}

function getCart() {
    return fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(e => e.json());
}

// Integration init
(() => {
    try {
        const storeId = 'a06fab6a-c0f9-4ab3-95b4-7eb6151a6e03';
        const environment = 'production';
        
        window.Extend.config({ storeId, environment});

        const config = getConfiguration();

        if (config.aftermarketModalEnabled)
            initAftermarket();

        if (config.atcOfferEnabled || config.offerModalEnabled || config.pdpOfferEnabled)
            initProductOffer();

        if (config.cartOfferEnabled || config.cartSPEnabled || config.sideCartOfferEnabled)
            initCartOffer();
    } catch (err) {
        /*
          Was: only logged when sessionStorage['extend.debug'] was set. That is
          why a null add-to-cart button silently removed the protection-plan
          offer from every PDP with no trace anywhere — the integration looked
          "not installed" rather than broken.

          console.warn (not error) keeps it out of error-reporting noise while
          making the failure discoverable to anyone with devtools open. The
          debug flag still upgrades it to a full trace.
        */
        if (sessionStorage.getItem('extend.debug')) {
            console.error('[Extend] init failed:', err);
        } else {
            console.warn('[Extend] init failed:', err && err.message ? err.message : err);
        }
    }
})();